var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 17.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.5,4.25a.85.85,0,1,0,.86.85A.86.86,0,0,0,8.5,4.25Zm0,3A.84.84,0,0,0,7.66,8v3.93a.86.86,0,0,0,.85.85A.85.85,0,0,0,9.36,12V8.09a.86.86,0,0,0-.86-.86ZM8.5,0A8.5,8.5,0,1,1,0,8.52,8.51,8.51,0,0,1,8.5,0h0Z",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.2b3b64323fef5462a7ada56968fa23aa.svg";
export { ForwardRef as ReactComponent };